import React from "react";
import { withRouter } from "react-router-dom";

import { Typography, IconButton, Grid } from "@material-ui/core";
import { MdShortText, MdDashboard } from "react-icons/md";
import {
  Backbutton,
  Loader,
  Card,
  SectionTitle,
  ProfileDashboard,
  Tabs
} from "../../components/_common";
import { Layout, Section } from "../../components/_layout";
import { FiMessageCircle } from "react-icons/fi";

import { useCompanyDetail } from "../../hooks";

import useStyles from "./styles";

const CompanyProfile = ({ match }) => {
  const [{ companyDetail, loadingCompanyDetail }] = useCompanyDetail(
    match.params.id
  );

  const { title, cdRoot, cdDescription, cdCampaigns, cdAvatar } = useStyles({
    companyDetail
  });

  if (loadingCompanyDetail) {
    return (
      <Layout
        leftContainerChildren={<Backbutton />}
        centerContainerChildren={<Loader size={24} />}
      >
        <Loader />
      </Layout>
    );
  }

  const {
    profile: { company_name, description },
    campaigns
  } = companyDetail;

  return (
    <Layout
      leftContainerChildren={<Backbutton />}
      centerContainerChildren={
        <Typography className={title} noWrap>
          {company_name}
        </Typography>
      }
      rightContainerChildren={
        <IconButton>
          <FiMessageCircle />
        </IconButton>
      }
    >
      <Grid container className={cdRoot}>
        <Section>
          <Grid item container className={cdAvatar} />
          <ProfileDashboard
            data={[
              { title: "Campañas lanzadas", value: campaigns.length },
              { title: "Campañas activas", value: campaigns.length }
            ]}
          />
        </Section>

        <Tabs
          tabs={[
            {
              title: "Campañas",
              icon: <MdDashboard fontSize="inherit" />,
              component: (
                <Grid container item xs className={cdCampaigns}>
                  <SectionTitle title="Campañas" />
                  {campaigns.map(campaign => (
                    <Card key={campaign.id} data={campaign} />
                  ))}
                </Grid>
              ),
              renders: true
            },
            {
              title: "Info",
              icon: <MdShortText fontSize="inherit" />,
              component: (
                <Grid container item xs className={cdDescription}>
                  <SectionTitle title="Bio" />
                  <Typography gutterBottom>{description}</Typography>
                </Grid>
              ),
              renders: true
            }
          ]}
        />
      </Grid>
    </Layout>
  );
};

export default withRouter(CompanyProfile);
